import React from "react"
import styles from "./Container.module.scss"

const Container = (props) => {
  let classes = `${styles.container}`;
  if (props.wide) {
    classes = `${classes} ${styles.wide}`;
  }
  if (props.fluid) {
    classes = `${classes}  ${styles.fluid}`;
  }
  if (props.dashboard) {
    classes = `${classes}  ${styles.dashboard}`;
  }
  if (props.className) {
    classes = `${classes}  ${props.className}`
  }

  return (
    <div className={classes}>{props.children}</div>
  )

}

export default Container
